import { createContext, useContext } from 'react';
/*
This context is about sharing formData with the widgets
*/
export const FormContext = createContext<{ formData: Record<string, unknown> }>({
  formData: {},
});

export const useFormData = () => useContext(FormContext);
